import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
var ZoneClassificationProperties = function ZoneClassificationProperties() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

  _classCallCheck(this, ZoneClassificationProperties);

  this.uniqueFieldValues = i, this.allAreNumeric = e, this.allAreNullOrEmpty = s;
};

var ZoneClassificationUtils = function ZoneClassificationUtils() {
  _classCallCheck(this, ZoneClassificationUtils);
};

ZoneClassificationUtils.MAX_UNIQUE_VALUE_THRESHOLD = 70, ZoneClassificationUtils.NUMBER_OF_FEATURES_CLASSIFY_THRESHOLD = 0, ZoneClassificationUtils.NUMBER_OF_CLASSES_UNIQUE_VALUE_THRESHOLD = 5, ZoneClassificationUtils.NATURAL_BREAKS_NUMBER_OF_CLASSES = 5, ZoneClassificationUtils.getFieldNames = function (i) {
  if (!i || 0 === i.length) return null;
  var e = new Intl.Collator(void 0, {
    numeric: !0
  });
  return _toConsumableArray(Object.keys(i[0].properties)).sort(e.compare);
}, ZoneClassificationUtils.getZoneClassificationProperties = function (i, e) {
  var s = new ZoneClassificationProperties();
  if (!i || !e) return s;
  var l = !0,
      t = !0;
  return i.forEach(function (i) {
    var n = i.properties[e];
    null != n && "" !== n && (t = !1), s.uniqueFieldValues.includes(n) || ("number" != typeof n && (l = !1), s.uniqueFieldValues.push(n));
  }), s.allAreNumeric = l, s.allAreNullOrEmpty = t, s;
};
export { ZoneClassificationProperties as Z, ZoneClassificationUtils as a };